import { render, staticRenderFns } from "./SearchList.vue?vue&type=template&id=035b9f5c&scoped=true&"
import script from "./SearchList.vue?vue&type=script&lang=js&"
export * from "./SearchList.vue?vue&type=script&lang=js&"
import style0 from "../../less/search.less?vue&type=style&index=0&id=035b9f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035b9f5c",
  null
  
)

export default component.exports